import { render, staticRenderFns } from "./BookletPartRead.vue?vue&type=template&id=0b1c5aae&scoped=true"
import script from "./BookletPartRead.vue?vue&type=script&lang=js"
export * from "./BookletPartRead.vue?vue&type=script&lang=js"
import style0 from "./BookletPartRead.vue?vue&type=style&index=0&id=0b1c5aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c5aae",
  null
  
)

export default component.exports